<h1 class="fw-bolder fs-4x text-gray-700 mb-10">{{"ERROR.TYPE_404.NOT_FOUND" | translate}}</h1>

<div class="fw-bold fs-3 text-gray-400 mb-15">
  {{"ERROR.TYPE_404.NOT_FOUND_DESC_1" | translate}} <br />
  {{"ERROR.TYPE_404.NOT_FOUND_DESC_2" | translate}}
</div>
